import {
  Section,
  TitleAndDescription,
  EmptyState,
  UpgradingIllustration,
} from '@ferreri/prever-component-lib';
import { useWhatsappApi } from 'utils/useWhatsappApi';

export const PetCremationBenefitEmptyState = () => {
  const { handleSendWhatsappMessage } = useWhatsappApi({
    phone: '+551132882526',
    text: 'Olá, gostaria de informações sobre Proteção Pet. Meu plano atual não possui esse benefício.',
  });

  return (
    <Section>
      <TitleAndDescription
        title="Plano sem benefício"
        description="Seu plano atual não possui o benefício de proteção pet."
      />
      <EmptyState
        illustration={<UpgradingIllustration />}
        description="Entre em contato com a central de atendimento para saber mais sobre esse benefício."
        buttonLabelPrimary="Entrar em contato pelo Whatsapp"
        onClickButtonPrimary={handleSendWhatsappMessage}
      />
    </Section>
  );
};
